export default function ({children}) {
    return children;
}